import { focusMapOnGeometry } from 'features/Responder/utils/focusMapOnGeometry';
import { normalizePoint } from './zoneGeometry';

const collectPointsForZoneAndDescendants = (zone, byId) => {
  if (!zone) return [];
  const points = Array.isArray(zone._points) && zone._points.length
    ? zone._points
    : [];
  const children = Array.isArray(zone.childrenIds) ? zone.childrenIds : [];
  const childPoints = children.flatMap((childId) => {
    const child = byId.get(`${childId}`);
    return collectPointsForZoneAndDescendants(child, byId);
  });
  return [...points, ...childPoints];
};

export const fitMapToZone = (map, zone, zones = [], padding = [60, 60]) => {
  if (!map || !zone) return;
  const byId = new Map(zones.map((z) => [`${z.id}`, z]));
  const allPoints = collectPointsForZoneAndDescendants(zone, byId).map((p) =>
    normalizePoint(p)
  ).filter(Boolean);
  focusMapOnGeometry(map, allPoints, {
    padding,
    maxZoom: 18,
    singlePointMinZoom: 18,
    singlePointMaxZoom: null,
  });
};
